import React from 'react';
import { Body, SubHeading, fontSize, fontFamilyMono } from '../../Constants/Fonts';

const typeStyle = (size, mono, style) => ({
    ...(size ? { fontSize: fontSize[size] } : null),
    ...(mono ? { fontFamily: fontFamilyMono } : null),
    ...style,
});

export function T({ as = 'span', size, mono, weight = 'regular', className = 'nova_t', style, ...rest }) {
    return <Body as={as} weight={weight} className={className} style={typeStyle(size, mono, style)} {...rest} />;
}

export function Title({ as = 'h3', size, mono, weight = 'semibold', className = 'nova_t', style, ...rest }) {
    return <SubHeading as={as} weight={weight} className={className} style={typeStyle(size, mono, style)} {...rest} />;
}
